<div class="container">
    <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Mit ERP-Sync</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <img mat-card-image class="example-image"
                        src="../../../../../../assets//undraw/undraw_advanced_customization.svg">
                    <p>
                      Die Kundendaten stammen aus einem ERP-Sync 
                      <br>
                      <br>
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="accent" [routerLink]="['add', withERP]">Starten</button>
                </mat-card-actions>
            </mat-card>
        </div>
        <div class="col-lg-6  col-md-12 col-sm-12">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Ohne ERP-Sync</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <img mat-card-image class="example-image"
                        src="../../../../../../assets/undraw/undraw_sign_in.svg">
                    <p>
                        Die Kundendaten stammen nicht  aus einem ERP-Sync 
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="accent" [routerLink]="['add', noERP]">Starten</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

</div>